<template>
  <div class="notice">
    <headerCom></headerCom>
    <div class="margin-bottom">
      <el-input
              type="textarea"
              :rows="20"
              placeholder="请输入内容"
              v-model="notice">
      </el-input>
    </div>
    <el-button type="success" class="margin-top" @click="saveNotice">设置公告</el-button>
  </div>
</template>

<script>
  import headerCom from '../components/header.vue'
  import App from '../util/comfun'
  import activitySetting from './components/activitySetting.vue'
  export default {
    //name: 'activitys',
    data () {
      return {
        notice:''
      }
    },
    components:{
      headerCom,
    },
    methods:{
      loadNotice(){
        App.demand('/sys/loadNotice','GET').then(res=>{
          this.notice=res.data||''
        })
      },
      saveNotice(){
        App.demand('/admin/activity/saveNotice','POST',{message:this.notice||''}).then(res=>{
          this.$message('设置成功')
        })
      },
    },
    mounted(){
      this.loadNotice();
    },

  }
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/pages/notice.vue